import { connect } from 'react-redux';
import { withProps, compose } from 'recompose';

import { getActiveBrandId, getShopNamesById, getShops } from '../../../../../auth/selectors';

const withCommonData = compose(
  connect(
    state => ({
      user: state.auth.user,
      permissions: state.auth.permissions,
      brandId: getActiveBrandId(state),
      brandShops: getShops(state),
      shopNamesById: getShopNamesById(state),
    }),
  ),
  withProps(() => ({
    showUsername: true,
  }))
);

export default withCommonData;
